import { typedDefineMessage } from 'src/components/utils/LanguageProvider/intl.helpers';


export default typedDefineMessage({
  emailPlaceholder: {
    id: 'app.sendEmailForm.sampleEmail',
    defaultMessage: 'joejoejoe@gmail.com',
  },
});
